import { render, staticRenderFns } from "./StackAreaChartPanel.vue?vue&type=template&id=19da8d10&scoped=true"
import script from "./StackAreaChartPanel.vue?vue&type=script&lang=js"
export * from "./StackAreaChartPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da8d10",
  null
  
)

export default component.exports